import React, {useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { Card } from "react-bootstrap";
import "../../App.css";
import ratingService from "../../services/ratingService";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import PropTypes from "prop-types";

const colors = {
    orange: "#FFBA5A",
    gray: "#a9a9a9"
};

function Home() {
    const navigate = useNavigate();
    const [selectedStars, setSelectedStars] = useState(0);
    const totalStars = 5;
    const stars = Array(totalStars).fill(0);
    const [hoverValue, setHoverValue] = useState();   
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [ipAddress, setIpAddress] =useState(null);
    const [optionalFormData, setOptionalFormData] = useState({
      name: "",
      email: "",
      comment: "",
    });
    
    useEffect(()=> {
      fetch("https://api.db-ip.com/v2/free/self").then(response => response.json())
      .then(data => setIpAddress(data.ipAddress))
      .catch(error => console.error("Error fetching IP:", error));
    }, []);

    const onStarClick = (starIndex) => {
      const newSelectedStars = starIndex + 1;
      console.log("selected stars:", newSelectedStars)
        setSelectedStars(newSelectedStars);              
    };

    const handleMouseOver = (starIndex) => {
        setHoverValue(starIndex);
    };

    const handleMouseLeave =() => {
        setHoverValue();
    };

    const onChangeHandler = (e) => {
      setOptionalFormData(prev => {
        const newData = {...prev};
        newData[e.target.name] = e.target.value;
        return newData;
      });
    };
      
    const onSubmitHandler = () => {        
      if (!selectedStars) {
        swal({
          icon: "error",
          title: "Oops...",
          text: "Please select a star rating to continue",
        });
        
       }  else {     
        setIsSubmitting(true);    
        const payload = {
        starRating: selectedStars,
        userIp: ipAddress,
        ...optionalFormData,
        };
       ratingService.submitRating(payload).then(onSubmitSuccess).catch(onSubmitError)
      }
    };    
    
    const onSubmitSuccess = () => {   
      setIsSubmitting(false);     
      if (selectedStars >= 1 && selectedStars <= 3){
        navigate("/thanks");
      } else if (selectedStars >= 4 && selectedStars <= 5){
        navigate("/thankyou");
      }  
    };

    const onSubmitError = (err) => {
      setIsSubmitting(false);
      console.log(err);
      
    };

    const onValidateHandler = () => {
      console.log("Submit button hovered");
        swal({
          icon: "error",
          title: "Oops...",
          text: "Please select a star rating to continue",
        });
    };

    FaStar.propTypes= {
      size: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      onMouseOver: PropTypes.func.isRequired,
      onMouseLeave: PropTypes.func.isRequired,
    };

    return (
        <React.Fragment> 
            <Card className="px-4 shadow-sm">  
        <div className="container">
          <h3 className="mt-3 mb-0 text-center">RATE US: </h3>
          <div className="stars text-center">
            {stars.map((_, index) => (
              <FaStar
                key={index}
                size={32}
                style={{ marginRight: 10, cursor: "pointer" }}
                color={
                  hoverValue !== undefined
                    ? hoverValue >= index
                      ? colors.orange
                      : colors.gray
                    : selectedStars > index
                    ? colors.orange
                    : colors.gray
                }
                className={
                  selectedStars > 0 ? "star selected" : "star"
                }
                onClick={() => onStarClick(index)}
                onMouseOver={() => handleMouseOver(index)}
                onMouseLeave={() => handleMouseLeave()}
              />
            ))}
          </div>   
          <div className="row g-2 mt-3" style={{alignItems: "end"}}>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div>
                <label htmlFor="NameFormControl" className="form-label small-text">
                  <h6 className="mb-0">Name (Optional):</h6>
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  onChange={onChangeHandler}
                />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div>
                <label htmlFor="EmailFormControl" className="form-label small-text">
                  <h6 className="mb-0">Email Address (Optional):</h6>
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="userEmail"
                  name="email"
                  onChange={onChangeHandler}
                />
              </div>
            </div>
          </div>
          <label htmlFor="CommentFormControl" className="form-label small-text mt-3">
            <h6 className="mb-0">Comments:</h6>
          </label>
          <textarea
            className="form-control"
            rows="4"
            id="Comment"
            name="comment"
            onChange={onChangeHandler}
          />
          <div className="d-flex justify-content-end mt-2 ml-auto">         
              {
                selectedStars === 0 ?
                <button type="button" disabled={isSubmitting} className="btn mb-2" style={{backgroundColor: "rgba(0, 123, 255, 0.2)"}} onClick={onValidateHandler}>Submit</button> :
                <button type="button" disabled={isSubmitting} className="btn btn-primary mb-2" onClick={onSubmitHandler}>Submit</button>
              }
          </div>          
        </div>
        </Card>
        </React.Fragment>
      );
    
}

export default Home;